import { useEffect } from 'react';
import SevereWeatherAlertsMap from '../../components/Maps/SevereWeatherAlertsMap/SevereWeatherAlertsMap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MapForecast from '../../components/Maps/MapForecast/MapForecast';
import Doppler from 'components/Maps/Doppler/Doppler';
import EarthquakeMap from 'components/Maps/Earthquake/EarthquakeMap';
import HurricanesTropicalStorms from 'components/StormCenter/HurricanesTropicalStorms';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { usePerms } from 'contexts/PermsContext';
import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { Container } from 'react-bootstrap';
import USGSFullScreen from 'pages/System/USGSFullScreen/USGSFullScreen';

export default function Maps() {
  const [params] = useSearchParams();
  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions(['MapsEnabled']))) {
        navigate('/404');
        return;
      }
    })();
  }, []);

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'usgs map':
        return <USGSFullScreen />;
      case 'severe weather warnings':
        return <SevereWeatherAlertsMap fullScreen />;
      case 'current conditions':
        return <MapForecast fullScreen />;
      case 'doppler':
        return <Doppler />;
      case 'earthquake':
        return <EarthquakeMap />;
      case 'hurricane':
        return <HurricanesTropicalStorms />;
      default:
        return <USGSFullScreen />;
    }
  };

  return (
    <Container fluid className="d-flex flex-column py-3 w-100">
      <div className="d-none d-lg-block w-100">
        <TabsHeader
          options={[
            { option: 'USGS Map' },
            { option: 'Severe Weather Warnings' },
            { option: 'Current Conditions' },
            { option: 'Doppler' },
            { option: 'Earthquake' },
            { option: 'Hurricane' },
          ]}
          styles={[{ fontSize: 12 }]}
        />
      </div>
      <div className="d-block d-lg-none w-100">
        <MobileTabsHeader
          options={[
            { option: 'USGS Map' },
            { option: 'Severe Weather Warnings' },
            { option: 'Current Conditions' },
            { option: 'Doppler' },
            { option: 'Earthquake' },
            { option: 'Hurricane' },
          ]}
        />
      </div>
      <div className="d-flex h-screen-80 w-100">{renderTab()}</div>
    </Container>
  );
}
